// temporary in-memory store (clears on refresh)
let CONTACT_STORE = [];
let ID_COUNTER = 1;

// fake email sender
const sendEmail = async ({ name, email, phone, loanType, message }) => {
  console.log("📩 Sending email to admin:");
  console.log({
    from: email,
    name,
    phone,
    loanType,
    message
  });

  // simulate async delay
  return new Promise(resolve => setTimeout(resolve, 500));
};
export const contactService = {
  createContact: async (contactData) => {
    const { name, email, phone, loanType, message } = contactData;

    // send "email" instead of saving to DB
    await sendEmail(contactData);

    // save small temp copy locally (optional)
    const newContact = {
      id: ID_COUNTER++,
      name,
      email,
      phone,
      loanType,
      message,
      status: "new",
      createdAt: new Date().toISOString()
    };

    CONTACT_STORE.push(newContact);

    return {
      success: true,
      message: 'Thank you! We will contact you soon.',
      data: newContact
    };
  },

  getAllContacts: async (status) => {
    let filtered = CONTACT_STORE;

    if (status) {
      filtered = CONTACT_STORE.filter(c => c.status === status);
    }

    return {
      success: true,
      data: filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    };
  },

  updateContactStatus: async (id, status) => {
    const index = CONTACT_STORE.findIndex(c => c.id === id);

    if (index === -1) {
      return { success: false, message: 'Contact not found' };
    }

    CONTACT_STORE[index].status = status;

    return {
      success: true,
      data: CONTACT_STORE[index]
    };
  },

  deleteContact: async (id) => {
    const index = CONTACT_STORE.findIndex(c => c.id === id);

    if (index === -1) {
      return { success: false, message: 'Contact not found' };
    }

    CONTACT_STORE.splice(index, 1);

    return {
      success: true,
      message: 'Contact deleted successfully'
    };
  }
};
